import capitalize from 'lodash-es/capitalize'
import sortBy from 'lodash-es/sortBy'
import React from 'react'

import { Button } from '@fourthwall/components'
import type { Type } from '@fourthwall/services/dist/models/variantType'

import { typeOrder } from '../ProductVariantType/consts'
import * as S from './AddButtons.styled'
import type { AddButtonsProps } from './types'

export const AddButtons = ({ allValues, setValues }: AddButtonsProps) => {
  if (allValues.length >= 3) return null

  const getSortedTypes = (variantTypes: any) => {
    return sortBy(variantTypes, (variantType) => typeOrder.indexOf(variantType.type))
  }

  const handleButtonClick = (type: Type) => {
    const newVariantType = {
      type,
      title: capitalize(type),
      options: [
        {
          name: '',
          images: [],
          colorSwatch: type === 'COLOR' ? '#000000' : undefined,
          weight: undefined,
        },
      ],
      variesBy: { price: false, imagery: false, weight: false },
    }

    setValues({ types: getSortedTypes([...allValues, newVariantType]) })
  }

  return (
    <S.Container>
      {!allValues.some((variantType) => variantType.type === 'COLOR') && (
        <Button
          label="Add different colors"
          appearance="secondary"
          onClick={() => handleButtonClick('COLOR')}
        />
      )}
      {!allValues.some((variantType) => variantType.type === 'SIZE') && (
        <Button
          label="Add different sizes"
          appearance="secondary"
          onClick={() => handleButtonClick('SIZE')}
        />
      )}
      {!allValues.some((variantType) => variantType.type === 'CUSTOM') && (
        <Button
          label="Add custom variants"
          appearance="secondary"
          onClick={() => handleButtonClick('CUSTOM')}
        />
      )}
    </S.Container>
  )
}
